const config = {
  timestampOffset: null,
  defaultOffset: null,
  timezoneOffset: null
};

export default config;
